// extracted by css-extract-rspack-plugin
export default {"container":"ekwKgg0kY5cRXSeQ0nTIm","content":"_3wLXlm69dDGQ0R_NTJt_TX"};